import React from 'react';
import RegisterKitEnter from './registerKit/registerKitEnter';

const RegisterKit = props => {
  return <RegisterKitEnter />;
};

export default RegisterKit;
